import script from "./IpdStatementUpdateTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IpdStatementUpdateTable.vue?vue&type=script&setup=true&lang=js"

import "./IpdStatementUpdateTable.vue?vue&type=style&index=0&id=a2a944f8&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2a944f8"]])

export default __exports__